import { jsx as r } from "react/jsx-runtime";
import { useMemo as e } from "react";
import { getAttributes as l, isStructTreeNode as m, isStructTreeNodeWithOnlyContentChild as o } from "./shared/structTreeUtils.es.js";
function a({ className: i, node: t }) {
  const n = e(() => l(t), [t]), u = e(() => !m(t) || o(t) ? null : t.children.map((s, c) => (
    // biome-ignore lint/suspicious/noArrayIndexKey: index is stable here
    r(a, { node: s }, c)
  )), [t]);
  return r("span", Object.assign({ className: i }, n, { children: u }));
}
export {
  a as default
};
//# sourceMappingURL=StructTreeItem.es.js.map
